import { getCurrentInstance } from 'vue'

const useGlobals = () => {
  const { $globals, translate, hitLozad, getVariable, getBlock } = _getGlobals()
  return {
    $globals,
    getVariable,
    getBlock,
    translate,
    hitLozad
  }
}

const _getGlobals = () => {
  // Always resolve from the calling component's own app. A module-level cache
  // would hand one request's globalProperties (and their store closures) to
  // another request's components on the server (VIP-12037), so there is no
  // fallback: outside a component context there is no app to read from.
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error('useGlobals() must be called from within setup()')
  }
  return instance.appContext.config.globalProperties
}

export { useGlobals }
